export default __webpack_public_path__ + "static/media/reward-big.b7da82d4.png";